export default __webpack_public_path__ + "static/ai-solutions-with-roadmap1-f0b7c6058d091a0616dcf2e734470a32.webp";